import script from "./admin-header.vue?vue&type=script&setup=true&lang=ts"
export * from "./admin-header.vue?vue&type=script&setup=true&lang=ts"

import "./admin-header.vue?vue&type=style&index=0&id=757b2396&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-757b2396"]])

export default __exports__